// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			
	}
};

(function () {  
	BoostPFS.inject(this);  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
			 if (!suggestionElement) suggestionElement = this.$uiMenuElement;   
		if (!searchElement) searchElement = this.$element;  
		if (!searchBoxId) searchBoxId = this.id; 
	};

	BoostPFS.prototype.beforeBuildSearchBox = function (id) {

		// Remove theme's instant search events
		var cloneSearchBar = jQ(id).clone();
		jQ(id).replaceWith(cloneSearchBar);      
		
		
		if (Utils.InstantSearch.isFullWidthMobile()) {
			jQ(id).removeAttr('autofocus');
			if (jQ(id).is(':focus')) {
				jQ(id).blur();
			}
		}
	};

	BoostPFS.prototype.afterCloseSuggestionMobile = function(searchBoxId, isCloseSearchBox) {
		// Close theme's search pop up
		if (isCloseSearchBox && window.$ && $.fancybox){
			$.fancybox.close(true);
		}
	};
  
  	
  
    var compileSuggestionProductPrice = InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice;
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
      if (this.data.price_min === 999.99 || this.data.tags.includes('Quote Only-true')) return '<span class="product__quote_only">Request Quote</span>'
      return compileSuggestionProductPrice.call(this);
    }
})();


// Only send Weglot request if the current language is different from English
// function isWeglotActive() {
//     if (!window.Weglot || !window.Weglot.initialized) {
//       	return false;
//     } else {
//     	var currentLang = Weglot.getCurrentLang();
// 	// Change 'en' to suitable with original language of the store
//     	return currentLang !== 'en';
//     }
// }
  
//  InstantSearchApi.beforeCallAsync = function(searchTerm, callInstantSearchApi) {
//     // Then use it in our API
//     if (window.Weglot && window.Weglot.initialized && isWeglotActive()) {
//         Weglot.search(searchTerm, function(englishTerm) {
// 		Globals.instantSearchQueryParams['q'] = englishTerm;
//         	callInstantSearchApi();
//        	});
//     } else {
//         callInstantSearchApi();
//     }
// }